import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Sidebar from './Sidebar'
import MainMenu from './MainMenu'
import DynamicSection from './DynamicSection'
import * as ComponentActions from '../actions'
import commonUI from '../../js/commonUI'
import { initPlugins } from '../lib/utils'

class Core extends Component {

  constructor({ components }) {
    super()
  }

  componentDidMount() {
    setTimeout(() => {
      commonUI.initializeSplitPanel();
      commonUI.initializeTabs();
      commonUI.initializeTabs({selector: '.js-tabs-lite', responsive: true});
      commonUI.initializeTabs({selector: '.js-scrollable-tabs', scrollable: true});
      commonUI.initializeDropdown();
      commonUI.initializeAlert();
      commonUI.initializeAlert({ selector: '.js-inline-alert-pending', closeSelector: '.js-inline-alert__close', autoCloseTime: null, inline: true, minimisedCellIndex: 2 });
      commonUI.initializeAlert({ selector: '.js-inline-alert', closeSelector: '.js-inline-alert__close', autoCloseTime: null, inline: true });
      commonUI.initializeTable();
      commonUI.initializeNavigation();
      commonUI.initializeSearch();
      commonUI.initializeAccordion();
      commonUI.initializeTooltip();
      commonUI.initializeTooltip({
        selector: '.tooltip-selector--light',
        theme: 'light'
      });
      commonUI.initializeTooltip({
        selector: '.tooltip-selector--alternative',
        theme: 'alternative'
      });
      commonUI.initializeTooltip({
        selector: '.tooltip-selector--white',
        theme: 'white'
      });
      commonUI.initializePagination();
      commonUI.initializeModal();
      commonUI.initializeTable({
        selector: '.js-table-reorder',
        tableReorder: 'js-table-reorder',
        overlayElement: '.example-overlay',
        trigger: 'trigger-one',
      });
      commonUI.initializeTable({
        selector: '.js-table--detail',
        detailViewType: 'detailedView',
        detailViewSelector: '.js-table-secondary-view',
        detailViewDismissSelector: '.js-table-secondary-view--dismiss'
      });
      commonUI.initializeTable({
        selector: '.js-table-detail-expanded',
        detailViewType: 'expandedRow',
        detailViewSelector: '.js-table-detail-expand-trigger'
      });
      commonUI.initializeTable({
        selector: '.js-table-detail-stacked',
        detailViewType: 'stackedRow',
        detailViewSelector: '.js-table-detail-stacked-trigger'
      });
      commonUI.initializeTable({
        selector: '.sample-edit'
      });
      commonUI.initializeDrawer('.example-drawer', {
        trigger: '.drawer-example-button'
      });
      commonUI.initializeDrawer('.example-drawer-left-small', {
        trigger: '.drawer-left-small-example-button'
      });
      commonUI.initializeDrawer('.example-drawer-large', {
        trigger: '.drawer-large-example-button'
      });
      commonUI.initializeDrawer('.example-drawer-xlarge', {
        trigger: '.drawer-xlarge-example-button'
      });
      commonUI.initializeDrawer('.example-drawer-events', { trigger: '.drawer-events-example-button' });

      commonUI.initializeDrawer('.example-drawer-tabbed', {
        tabbed: true,
        trigger: '.js-drawer-bottom-toggle'
      });
      commonUI.initializeDrawer('.example-drawer-tabbed-alt', {
        tabbed: true,
        trigger: '.js-alt-drawer-bottom-toggle'
      });
      commonUI.initializeButtonGroup();
      commonUI.initializeAlert({
        selector: '.alert--update-browser',
        updatedBrowser: {
          chrome: '73.0.0',
          safari: '13.0.0',
          firefox: '66.0.0',
          ie: '12.0.0',
        },
      });
      commonUI.initializeModal({
        selector: '.delete-row-modal',
        clickElementSelector: '.delete-row',
      });

      let eventsExampleModal = document.getElementsByClassName('events-example-modal')[0];
      eventsExampleModal.addEventListener('show.commonui.modal', function(){
        console.log('modal show')
      });
      eventsExampleModal.addEventListener('hide.commonui.modal', function(){
        console.log('modal hide')
      });
      eventsExampleModal.addEventListener('positive.commonui.modal', function(){
        console.log('modal positive')
      });
      eventsExampleModal.addEventListener('negative.commonui.modal', function(){
        console.log('modal negative')
      });

      let eventsDrawerExample = document.getElementsByClassName('example-drawer-events')[0];
      eventsDrawerExample.addEventListener('show.commonui.drawer', function(){
        console.log('drawer show')
      });
      eventsDrawerExample.addEventListener('hide.commonui.drawer', function(){
        console.log('drawer hide')
      });
      eventsDrawerExample.addEventListener('positive.commonui.drawer', function(){
        console.log('drawer positive')
      });
      eventsDrawerExample.addEventListener('negative.commonui.drawer', function(){
        console.log('drawer negative')
      });
      let tableReorderExample = document.getElementsByClassName('js-table-reorder')[0];
      tableReorderExample.addEventListener('apply.commonui.reorderTable', function(event) {
        console.log('Saved Table: ', event.detail);
      });
      initPlugins();
    }, 0);
  }

  getFilteredContent(components) {
    return components.Core
  }

  renderMainMenu(components, staticVersion) {
    return (<MainMenu components={components} staticVersion={staticVersion} selected="Core"/>)
  }
  renderSidebar(filteredContent) {
    return (<Sidebar sections={filteredContent} selected="Core"/>)
  }

  render (){
    const { components } = this.props
    const staticVersion = this.props.config.staticVersion;
    const filteredContent = this.getFilteredContent(components);
    return(
      <div>
        {this.renderMainMenu(components, staticVersion)}
        {this.renderSidebar(filteredContent)}
        <div id="main" className="content">
          <div className="grid">
            <div className="grid__col-sm-12 main">
              {filteredContent.map((object, index) => {
                return (
                  <DynamicSection
                    key={object.template}
                    sectionName={object.template}
                    staticVersion={staticVersion}/>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(ComponentActions, dispatch)
  }
}

function mapStateToProps(state) {
  return { components: state.components, config: state.config }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Core)



// WEBPACK FOOTER //
// ./styleguide/components/Core.js